export const Types = {
  GET_REVIEWS_DATA: 'GET_REVIEWS_DATA',
  GET_REVIEWS_DATA_SUCCESS: 'GET_REVIEWS_DATA_SUCCESS',
  GET_REVIEWS_DATA_FAIL: 'GET_REVIEWS_DATA_FAIL',
  REQUEST_ACT_DELETE_REVIEW: 'REQUEST_ACT_DELETE_REVIEW',
  DELETE_ACT_REVIEWS: 'DELETE_ACT_REVIEWS',
  RESET_REVIEWS_DATA: 'RESET_REVIEWS_DATA',
  SET_ACT_MODAL: 'SET_ACT_MODAL',
};

const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  showModal: false,
  pagination: {
    currentPage: 1,
    limitPerPage: 3,
    totalItems: null,
    previousPage: null,
    nextPage: null,
  },
};

const data = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_REVIEWS_DATA:
      return { ...state, loading: true };
    case Types.GET_REVIEWS_DATA_SUCCESS:
      const { data, pagination } = action.payload;
      return { data: [...state.data, ...data], pagination: pagination, loading: false, error: null };
    case Types.GET_REVIEWS_DATA_FAIL:
      return { ...state, error: action.payload, loading: false };
    case Types.REQUEST_ACT_DELETE_REVIEW:
      return {
        ...state,
        loading: true,
      };
    case Types.DELETE_ACT_REVIEWS:
      const newData = state.data.filter(item => item.id !== action.payload);
      return {
        ...state,
        data: newData,
        loading: false,
      };
    case Types.RESET_REVIEWS_DATA:
      return (state = INITIAL_STATE);
    case Types.SET_ACT_MODAL:
      return {
        ...state,
        showModal: action.payload,
      };
    default:
      return { ...state };
  }
};

export const Actions = {
  getReviewsData: (id, filters) => ({
    type: Types.GET_REVIEWS_DATA,
    payload: {
      id,
      filters,
    },
  }),
  getReviewsDataSuccess: reviews => ({
    type: Types.GET_REVIEWS_DATA_SUCCESS,
    payload: reviews,
  }),
  getReviewsDataFailed: error => ({
    type: Types.GET_REVIEWS_DATA_FAIL,
    payload: error,
  }),
  resetReviewsData: () => ({
    type: Types.RESET_REVIEWS_DATA,
  }),
  requestDeleteActReview: (reviewId, actId) => ({
    type: Types.REQUEST_ACT_DELETE_REVIEW,
    payload: {
      reviewId: reviewId,
      actId: actId,
    },
  }),
  deleteActReviews: reviewId => ({
    type: Types.DELETE_ACT_REVIEWS,
    payload: reviewId,
  }),
  setActModal: payload => ({
    type: Types.SET_ACT_MODAL,
    payload,
  }),
};

export default data;
